<template>
    <client-page class="wrap--sub">
        <!-- 서브비주얼 -->
        <sub-visual :visual="'페이지소개'"></sub-visual>

        <div class="contents pb-none">
            <section class="section section--intro">
                <div class="ct">
                    <img src="/images/sub/about/about-intro-image.jpg" alt="">
                    <div class="about-intro">
                        <div class="about-intro__col">
                            <h3 class="tit">
                                <span class="font-en">SBA</span> 국제유통센터 <br>
                                <span class="color-primary"><span class="font-en">B2B</span> 매칭상담회 플랫폼</span>
                            </h3>
                        </div>
                        <div class="about-intro__col">
                            <p class="txt">서울어워드 상품과 SBA 국제유통센터에서 발굴한 바이어 간 매칭을 지원합니다.</p>
                            <p class="txt">
                                해외로 수출할 만한 우수한 상품을 찾는 유통인들과 우수한 제품을
                                국내외 유통 및 수출할 수 있는 판로 개척이 필요한 중소기업을 위해
                                유통 채널이 입점된 B2B 매칭상담회 플랫폼입니다.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section section--qna">
                <div class="ct">
                    <ul class="about-qna">
                        <li class="about-qna__list">
                            <div class="about-qna__head">
                                <em class="badge">Q1</em>
                                <p class="tit">계정 정보는 어떻게 확인할 수 있나요? </p>
                            </div>
                            <div class="about-qna__body">
                                <p class="txt">
                                    중소 제조기업 분들에게는 서울어워드 신청시 기재한 메일로 계정
                                    정보를 전달드렸습니다. 메일을 확인하셔서 로그인후 마이페이지에서
                                    정보 수정을 부탁드리겠습니다.
                                </p>
                            </div>
                        </li>
                        <li class="about-qna__list">
                            <div class="about-qna__head">
                                <em class="badge">Q2</em>
                                <p class="tit">매칭상담회 셀러로 참여하고 싶어요!</p>
                            </div>
                            <div class="about-qna__body">
                                <p class="txt">
                                    B2B 매칭상담회에는 SBA 국제유통센터에서 진행하는 ‘서울어워드’,
                                    ‘슈퍼루키’에 참여한 기업만 참여하실 수 있습니다.
                                </p>
                                <a href="https://smc.sba.kr/Pages/BusinessInfo/HiSeoulAward.aspx?p=0" target="_blank" class="button button--round button--border-white"><span>서울어워드 신청 바로가기</span></a>
                            </div>
                        </li>
                        <li class="about-qna__list">
                            <div class="about-qna__head">
                                <em class="badge">Q3</em>
                                <p class="tit">매칭상담회 바이어로 참여하고 싶어요!</p>
                            </div>
                            <div class="about-qna__body">
                                <p class="txt">
                                    바이어로 참여를 희망하실 경우, 하단 링크를 통해 바이어 지원을
                                    해주시면 검토 후 개별 연락을 드릴 예정입니다.
                                </p>
                                <a href="https://forms.gle/tRqixDVHd69aucU66" target="_blank" class="button button--round button--border-white"><span>바이어 신청 바로가기</span></a>
                            </div>
                        </li>
                    </ul>
                </div>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.section{
    padding: 140px 0;
    &--intro { padding-top: 0; }
    &--qna { background: url('/images/sub/about/about-qna-background.jpg') no-repeat center bottom / cover; }
}
.about-intro{
    display: flex; margin: 0 -10px; line-height: 1.8; font-size: 18px; color: #666666;

    .tit { line-height: 1.2; font-size: 48px; font-weight: 700; color: #222222; }
    .txt:first-child { margin-bottom: 20px; color: #222222; font-weight: 700; }
    &__col { flex: 1 1; padding: 40px 10px 0; }
}
.about-qna{
    line-height: 1.8; font-size: 18px; color: #fff;

    .tit { flex: 1 1; color: inherit; }
    .txt { font-weight: 300; }
    .badge{
        display: flex; align-items: center; justify-content: center; margin: -12px 20px 0 0; width: 70px; height: 70px;
        line-height: 1; font-style: normal; font-size: 24px; font-weight: 600;
        background: rgba(255, 255, 255, 0.2); border-radius: 50%;
    }
    .button--border-white { margin-top: 20px; width: 350px; border-width: 2px; }
    &__list { display: flex; margin-bottom: 80px; }
    &__list:last-child { margin-bottom: 0; }
    &__head { flex: 1 1; display: flex; padding-right: 50px; }
    &__body { flex: 1 1; padding-left: 50px; }
}
@media(max-width:1200px){
    .section {
        padding: 120px 0;
        &--intro { padding-top: 0; }
    }
    .about-intro {
        font-size: 17px;

        .tit { font-size: 38px; }
    }
    .about-qna{
        font-size: 16px;
        .badge { margin-top: -7px; width: 50px; height: 50px; font-size: 20px; }
        &__list { flex-direction: column; }
        &__body { padding-left: 70px; }
    }
}
@media(max-width:768px){
    .section {
        padding: 100px 0;
        &--intro { padding-top: 0; }
    }
    .about-intro {
        flex-direction: column; font-size: 16px;

        .tit { font-size: 22px; }

        &__col { padding: 30px 10px 0; }
    }
    .about-qna{
        font-size: 15px;

        .badge { margin: 0 0 10px; font-size: 17px; }
        .button--border-white { width: 100%; }
        &__list { margin-bottom: 60px; }
        &__head { flex-direction: column; margin: 0 0 10px; padding-right: 0; }
        &__body {padding-left: 0; }
    }
}
</style>